<template>
  <div class="edit-profilebox add-new-memberbox savingaccount-formbox">
    <ul class="breadcrumbs-list">
      <a  @click="backButton"><li>Investment</li></a>
      <a  @click="depositeDashbord"><li>&nbsp;>&nbsp;Retirement Dashboard</li></a>
      <a  @click="depositeAccounts"><li>&nbsp;>&nbsp;Retirement</li></a>

      <li>&nbsp;>&nbsp;Public Provident Fund</li>
    </ul>
    <h4 class="welcome-text">Public Provident Fund</h4>
    <div>
      <div class="edit-profilebox-detail">
        <v-form
          ref="form"
          id="saving_account"
          @submit.prevent
          class="login-form-box register-page"
          lazy-validation
        >
            <h4>Enter Details</h4>
            <v-row >
              <v-col xs="12" md="6" class="member_relation_box col" v-for="formAttr in formAttributes" :key="formAttr.id">
                <label class="member-label" v-if="formAttr['name'] =='current_balance'">{{formAttr['label']}} As On {{currentDate | moment("DD MMM, Y")}}</label>
                <label class="member-label" v-else>{{formAttr['label']}} </label>
                <div v-if="formAttr['type'] == 'select' && formAttr['name'] !='nominee'">
                  <v-select
                    ref="form_attrs"
                    :name="formAttr['name']" 
                    :v-model="formAttr['name']"
                    :items="(formAttr['name']=='account_type' )? accountType : (formAttr['name']=='bank_name') ? bank : (formAttr['name']=='account_owner')? account_owner :(formAttr['name']=='depositor_name')? depositor_name : ((formAttr['name']=='nominee')) ? joint_account_owner :(formAttr['name']=='joint_account_owner')? joint_account_owner:familyMember"
                    item-value="id"
                    item-text="name"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                  ></v-select>
                </div>
                <div v-else-if="formAttr['type'] == 'select' && formAttr['name'] =='nominee'">
                   <v-combobox
                    :ref="formAttr['name']"
                    :name="formAttr['name']" 
                    v-model="addMoreField"
                    :items="nominee"
                    item-value="id"
                    item-text="name"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                    multiple
                    small-chips
                    solo
                    v-on:input="limiter"
                    deletable-chips
                  ></v-combobox>
                    <a @click="appendField" class="add-newbox">Add New Nominee</a>
                </div>
                <div v-else-if="formAttr['type'] == 'input' && formAttr['name'] != 'account_no'" :class="(formAttr['name'] == 'amount_invested' || formAttr['name'] == 'current_balance'||  formAttr['name'] == 'maturity_amount')? 'rupee-icon' : ''">
                    <v-text-field
                    :disabled="(formAttr['name'] == 'current_balance' )|| (formAttr['name'] == 'maturity_amount') ? true: false"
                    :name="formAttr['name']"
                    ref="form_attrs" 
                    :rules="[(formAttr['is_required'] ==true ? v => !!v || 'Field is required':[]),(formAttr['is_numeric'] ==true ? v => v => /^\d{0,8}[.]?\d{1,2}$/ .test(v)  || 'Field must be numeric':[])]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    @input="calculateAmounts()"
                    :value="formAttr['name'] == 'current_balance'? current_balance_value:formAttr['name'] == 'maturity_amount'? maturity_balance_value:''"
                    ></v-text-field> 
                </div>
                <div v-else-if="formAttr['type'] == 'input' && formAttr['name'] == 'account_no'">
                    <v-text-field
                    :name="formAttr['name']"
                    ref="form_attrs" 
                    :rules="formAttr['is_required'] == false ? [ v => !v || /^(?=.*[0-9])[a-zA-Z0-9]+$/.test(v) || 'Field must be alphanumeric or numeric']:[]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    @input="changeTextFieldEvent"
                    ></v-text-field>
                </div>
                <div v-else-if="formAttr['type'] == 'date' && formAttr['name'] == 'start_date'" class="dob-box">
                  <Datepicker
                    :name="formAttr['name']" 
                    ref="form_attrs"
                    :v-model="formAttr['name']"
                    format="yyyy-MM-dd"
                    :placeholder="formAttr['place_holder']"
                    :disabledDates="disabledDates"
                    @selected="maturityDateConversion($event,formAttr['name'])"
                  ></Datepicker>
                </div>
                <div v-else-if="(formAttr['type'] == 'date') && (formAttr['name'] == 'end_date')" class="dob-box">
                  <Datepicker
                    class="no-click"
                    :name="formAttr['name']" 
                    ref="form_attrs"
                    :v-model="formAttr['name']"
                    format="yyyy-MM-dd"
                    :value="maturity_date"
                    placeholder="Please select Maturity date"
                    @selected="maturityDateConversion($event,formAttr['name'])"
                  ></Datepicker>
                </div>
                <div v-else-if="formAttr['type'] == 'date'" class="dob-box">
                  <Datepicker
                    :name="formAttr['name']" 
                    ref="form_attrs"
                    :v-model="formAttr['name']"
                    format="yyyy-MM-dd"
                    :placeholder="formAttr['place_holder']"
                   :disabledDates="disabledDates"
                  ></Datepicker>
                </div>
              </v-col>
            </v-row>
           <!--  <v-row>
                <v-col xs="12" md="6" class="member_relation_box col"  v-for="(field, field_index) in other_form_field">
                   <div class="form-group">
                      <v-text-field
                        :name="field_index" 
                        :v-model="field['name']"
                        placeholder="Enter Nominee"
                        @change="appendFieldOnNominee(field_index, $event)"
                        ></v-text-field>
                      <a @click="removeField(field_index)" style="color: red">Remove</a>
                    </div>
                </v-col>
            </v-row> -->
            <span
              v-bind:class="{'error-messagebox-login': isAddClassServerError}"
              id="server_side_error"
              >{{serverError}}</span
            >
            <v-row class="buttonbox">
              <v-btn class="blue-border-btn" @click="depositeAccounts"> Cancel </v-btn>
              <v-btn
                class="blue-btn"
                @click="submit"
                 :disabled="!isFormValid"
              >
                Save
              </v-btn>
            </v-row>
          </v-form>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import axios from 'axios';
import Datepicker from 'vuejs-datepicker'
import { validationMixin } from 'vuelidate'
import {required, email, minLength, sameAs, isAlphanumeric, alpha, numeric, maxLength} from "vuelidate/lib/validators";
import { Auth } from 'aws-amplify';
import JwtService from "../../.././common/jwt.service";
import { POST_API, GET_API, GET_PPF_FORM, GET_RETIREMENT_FORM_DETAIL, SAVE_RETIREMENT_FORM_DETAIL } from "../../../../store/actions.type";
import ApiService from "../../../../api/api.service";
import { isEmpty } from 'lodash';
export default {
    components: {
      Datepicker,
    },
    mixins: [validationMixin],
    validations: {
      
    },
    data: () => ({
      valid: true,
      submitted: false,
      activePicker: null,
      menu: false,
      isFormValid:false,
      disabledDates: {
        from: new Date()
      },
      serverError:'',
      isAddClassServerError:false,
      formAttributes:'',
      formAttr:'',
      other_form_field:[],
      accountType:[],
      bank:[],
      familyMember:[],
      nominee:[],
      other_nominee:[],
      
      curr_balance_date: '',
      account_type:'',
      bank_name:'',
      account_owne:'',
      addMoreField:[],
      nomineeMembers:[],
      form_id:'',
      account_owner:[],
      depositor_name:[],
      nominee:[],
      current_balance_value:'',
      maturity_balance_value:'',
      joint_account_owner:[],
      currentDate: new Date().setDate(new Date().getDate()),
      allow_nominee:1,
       maturity_date:'',
    }), 
    created (){
      Fire.$on("loadData", () => {
        this.getAddFormData();
      });
    },
    mounted () {

      if (isEmpty(this.$store.getters.getPpfForm)) {
        this.getAddFormData();
      }else {
        this.allow_nominee = this.$store.getters.getPpfForm.allow_nominee;
        this.form_id = this.$store.getters.getPpfForm.data.form_id;
        this.formAttributes = this.$store.getters.getPpfForm.data.form_attributes.fields;
        let masterDataArr = this.$store.getters.getPpfForm.data.master_data;
        masterDataArr.forEach(element => {
          if (element.AccountType) {
            element.AccountType.forEach(dataAccountType => {
              this.accountType.push({'id':dataAccountType.id, 'name':dataAccountType.name});
            });
          }
          if (element.FamilyMember) {
            element.FamilyMember.forEach(dataFamily => {
              //if (dataFamily.id != '') {
                this.nominee.push(dataFamily.name);
             // }
              if(dataFamily.id == 0){
                this.account_owner.push({'id':'0', 'name':dataFamily.name});
              }
              else{
                this.account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
              }
              this.depositor_name.push({'id':dataFamily.id, 'name':dataFamily.name});
              this.joint_account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
            });
          }
        })
      }
    },
    methods: {
       changeTextFieldEvent(e) {
        this.isFormValid = this.$refs.form.validate()
      },
      limiter(e) {
      if((e.length + this.other_form_field.length) > 3) {
        swal.fire({
              title: 'Nominee',
              text: "You can add maximum 3 nominees.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              //cancelButtonColor: '#d33',
              confirmButtonText: 'OK',
              //cancelButtonText:'No'
            }).then((result) => {
              if (result.isConfirmed) {
                e.pop();
                return;
                
              }
            })
      }
    },
      validate () {
        this.$refs.form.validate()
      },
      backButton(){
        this.checkFormData = [];
         let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        this.checkFormData.length > 0 ?  swal
        .fire({
          title: "Your data will be cleared. Are you sure you want to close this?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        }).then(result => {
          
          if (result.isConfirmed) {
            this.$router.push({ name: 'Investment'}).catch(()=>{})
          }
        }) : this.$router.push({ name: 'Investment'}).catch(()=>{});
      },
      depositeAccounts(){
        // this.checkFormData = [];
        //  let getFormData = document.querySelector("#saving_account");
        // var formData = new FormData(getFormData)
        // for (const [key, value] of formData.entries()) {
        //   if (value) {
        //     this.checkFormData.push(value);
        //   }
        // }
        // this.checkFormData.length > 0 ?  swal
        // .fire({
        //   title: "Your data will be cleared. Are you sure you want to close this?",
        //   showCancelButton: true,
        //   confirmButtonColor: `#051d42`,
        //   confirmButtonText: `YES`,
        //   cancelButtonColor: `#f19700`,
        // }).then(result => {
          
        //   if (result.isConfirmed) {
        //     this.$router.push({ name: 'SubCategory'}).catch(()=>{})
        //   }
        // }) : this.$router.push({ name: 'SubCategory'}).catch(()=>{});
        this.$router.push({ name: 'SubCategory'});
      },
      appendField(){
         swal.fire({
          input: 'text',
          inputPlaceholder: 'Enter Nominee',
          inputAttributes: {
          autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: `Save`,
          allowOutsideClick: false,
          allowEscapeKey: false
          }).then((result) => {
            if (result.value) {
             let letters = /^[A-Za-z]+$/;
              if(result.value.length > 30){
                 swal.fire({
                  title: 'Nominee',
                  text: "Nominee Name may not be greater than 30 character.",
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonColor: '#051d42',
                  confirmButtonText: 'OK',
                  }).then((result) => {
                  if (result.isConfirmed) {
                    e.pop();
                    return;
                  }
                })
              }else if(result.value.match(letters))
                {
                  
                this.nominee.push(result.value);
                this.addMoreField.push(result.value);
                }
              else
                {
              swal.fire({
              title: 'Nominee',
              text: "Please enter valid name.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              confirmButtonText: 'OK',
              }).then((result) => {
              if (result.isConfirmed) {
                e.pop();
                return;
               
              }
            })
                }
              
            }
             if (result.value == "") {
            swal
              .fire({
                title: "Nominee",
                text: "This field is required.",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#051d42",
                confirmButtonText: "OK",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  e.pop();
                  return;
                }
              });
          }
          })
       
       
        if (this.addMoreField.length >= 3) {
         swal.fire({
              title: 'Nominee',
              text: "You can add maximum 3 nominees.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              //cancelButtonColor: '#d33',
              confirmButtonText: 'OK',
              //cancelButtonText:'No'
            }).then((result) => {
              if (result.isConfirmed) {
                e.pop();
                return;
                
              }
            })
        }
      }, 
      removeField (lineId) {
        this.other_form_field.splice(lineId, 1);
      },
      setData(key){
        console.log(key);
      }, 
      submit(e) {

        /*if (this.end_date && this.start_date) {

           if(this.start_date > this.end_date){
            swal
              .fire({
              title: "End Date should be after Start date.",
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `Ok`,
              cancelButtonColor: `#f19700`,
              denyButtonText: `NO`
              }).then(() => {
                
              })
              return;
            }

              
        }*/
         this.isFormValid = this.$refs.form.validate()
         let getFormData = document.querySelector("#saving_account");
        this.checkFormData = [];
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        if (this.checkFormData.length > 0) {

            this.submitted = true;
            this.$loading(true)
            let jsonObject = []
            let nominee    = []
            let i=0;
            for (const [key, value] of formData.entries()) {
              if(key == 'nominee' && value !=''){
                value.split(",").forEach(nomineeData => {
                  nominee.push(nomineeData)
                });
              }
              else if(Number.isInteger(parseInt(key)) == true){
                nominee.push(value)
              }
              else if(key == 'start_date' || key == 'end_date'){
                if (value == '') {
                  jsonObject.push({"key":key, "values":value})
                }else{
                  jsonObject.push({"key":key, "values":moment(String(value)).format('YYYY-MM-DD')})
                }
              }
              else if(key == "account_owner" || key == "account_type" || key == "bank_name" ){
                jsonObject.push({"key":key, "values":parseInt(value) })
              }
              else{
                if(key != 'nominee'){
                  jsonObject.push({"key":key, "values":value})
                }
              }
              i++;
            }
            let nomineeArr = {"key":"nominee", "values":nominee}
            jsonObject.push(nomineeArr)
            let collected_data = {"collected_data":jsonObject};

            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            this.$store.dispatch(SAVE_RETIREMENT_FORM_DETAIL, {
              data: {
                aws_cognito_id: cognito_idp,
                form_id:this.form_id,
                account_owner:getFormData.account_owner.value,
                form_detail:JSON.stringify(collected_data),
              },
              api: 'save-retirement-form-detail',
            }).then(() => {
               
                this.$loading(false)
                // Fire.$emit('providentFund');
                this.savingAccountList();
                Toast.fire({
                    icon: 'success',
                    title: "Public Provident Fund form submitted successfully"
                  })
              this.$router.push({ name: "retirement-dashboard", params: { tab: 'tab-1' }}).catch(()=>{});
            }).catch(() => {
                this.$loading(false)
            })

        }else{
          return;
        }
      },
      setMasterData:function(attr_type, val){
        // console.log(attr_type, val)
        // console.log('=====>',this.$store.getters.getBankPostData)
        let bankPost = this.$store.getters.getBankPostData;
        if(attr_type == 'account_type'){
          this.bank = [];
          bankPost.forEach(attrData => {
            // console.log(attrData)
            if(attrData['id'] == val){
              attrData['list'].forEach(databank => {
                this.bank.push({'id':databank.id, 'name':databank.name});
              });
            }
          });
        }
        else if (attr_type == 'account_owner') {
          let i = 0;
          this.nominee = [];
          this.depositor_name = [];
          this.joint_account_owner = [];
          let masterDataArr = this.$store.getters.getPpfForm.data.master_data;
          this.addMoreField = [];
          masterDataArr['2']['FamilyMember'].forEach(
            familyMember => {
              if (parseInt(val) != parseInt(familyMember['id'])) {
                  //if (familyMember.id != '') {
                    this.nominee.push(familyMember.name);
                 // }
                  this.joint_account_owner.push({'id':familyMember.id, 'name':familyMember.name});
                  this.depositor_name.push({'id':familyMember.id, 'name':familyMember.name});
              }
              i++;
          });
        }
      },
      appendFieldOnNominee(attr_type, val){
        this.nominee.push(val);
        this.addMoreField.push(val);
        this.other_form_field.splice(attr_type, 1);
      },
      depositeDashbord(){
        //  let getFormData = document.querySelector("#saving_account");
        // this.checkFormData = [];
        // var formData = new FormData(getFormData)
        // for (const [key, value] of formData.entries()) {
        //   if (value) {
        //     this.checkFormData.push(value);
        //   }
        // }
        // this.checkFormData.length > 0 ?  swal
        // .fire({
        //   title: "Your data will be cleared. Are you sure you want to close this?",
        //   showCancelButton: true,
        //   confirmButtonColor: `#051d42`,
        //   confirmButtonText: `YES`,
        //   cancelButtonColor: `#f19700`,
        // }).then(result => {
          
        //   if (result.isConfirmed) {
        //     this.$router.push({ name: "deposit-dashboard"}).catch(()=>{})
        //   }
        // }) : 
        this.$router.push({ name: "retirement-dashboard"}).catch(()=>{});
      },

       maturityDateConversion(type,name){
        let year = 0;
        if (true) {
          year = (name == "start_date") ? (parseInt(this.$moment(type).format("Y")) + 15).toString() : new Date();
          let date = type;
          let month = date.getMonth();
          let days = date.getDate();
          this.maturity_date = new Date(year,month,days);
        }
      },
      calculateAmounts(){
         this.isFormValid = this.$refs.form.validate()
       },
      calculateAmountsWithDates(e, attribute){
        
        if(attribute == 'start_date'){
          this.start_date = e;
        }
        else if(attribute == 'end_date'){
          this.end_date = e;
        }

        if (attribute == 'start_date' || attribute == 'end_date') {
            if ((this.start_date != '') && (this.end_date != '')) {

                (this.start_date > this.end_date) ?  swal
                .fire({
                title: "End Date should be after Start date.",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: `#051d42`,
                confirmButtonText: `Ok`,
                cancelButtonColor: `#f19700`,
                }).then(() => {
                  
                }):'';


                (this.end_date < this.start_date) ?  swal
                .fire({
                title: "End Date should be after Start date.",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: `#051d42`,
                confirmButtonText: `Ok`,
                cancelButtonColor: `#f19700`,
                }).then(() => {
                  
                }):'';
          }
        }    
      },
      savingAccountList(){
        this.$loading(true);
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let user_name = this.$store.getters.getUserDetails.user_name;
        let selected_value = this.$store.getters.getUserDetails.selected_value;
        this.$store.dispatch(GET_RETIREMENT_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            aws_cognito_id: cognito_idp,
            user_name:user_name,
            member_id:selected_value,
          },
          api: "get-retirement-form-detail",
        })
        .then(() => {
            Fire.$emit('retirementGraphData');
             this.$loading(false);

        }).catch(() => {
           this.$loading(false);
        });
      },
      getAddFormData (){
      
      // this.$loading(true)
      // var data = JSON.stringify({"aws_cognito_id":atob(localStorage.getItem('cognito_idp')), "form_type":20, "user_name": this.authUser.user_name});
      // var config = {
      //   method: 'post',
      //   url: process.env.VUE_APP_ROOT_API + 'get-retirement-form',
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': 'Bearer '+localStorage.getItem("api_token")
      //   },
      //   data : data
      // };
      // axios(config)
      // .then(() => {
        if(this.$store.getters.getUserDetails.user_name){  
          this.$loading(true);
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let user_name = this.$store.getters.getUserDetails.user_name;
          let selected_value = this.$store.getters.getUserDetails.selected_value;
          this.$store.dispatch(GET_PPF_FORM, {
            data: {
              aws_cognito_id: cognito_idp,
              user_name:user_name,
              form_type: 20,
            },
            api: "get-retirement-form",
          })
          .then(() => {
            this.allow_nominee = this.$store.getters.getPpfForm.allow_nominee;
            this.form_id = this.$store.getters.getPpfForm.data.form_id;
            this.formAttributes = this.$store.getters.getPpfForm.data.form_attributes.fields;
            // localStorage.setItem('form_attr_master_data', JSON.stringify(this.$store.getters.getPpfForm.data.data.master_data))
            let masterDataArr = this.$store.getters.getPpfForm.data.master_data;
            masterDataArr.forEach(element => {
              if (element.AccountType) {
                // localStorage.setItem('bank_po_master_data', JSON.stringify(element.AccountType))
                element.AccountType.forEach(dataAccountType => {
                  this.accountType.push({'id':dataAccountType.id, 'name':dataAccountType.name});
                });
              }
              if (element.FamilyMember) {
                element.FamilyMember.forEach(dataFamily => {
                  //if (dataFamily.id != '') {
                    this.nominee.push(dataFamily.name);
                 // }
                  if(dataFamily.id == 0){
                    this.account_owner.push({'id':'0', 'name':dataFamily.name});
                  }
                  else{
                    this.account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
                  }
                  this.depositor_name.push({'id':dataFamily.id, 'name':dataFamily.name});
                  this.joint_account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
                });
              }
            });
            this.$loading(false)
          })
          .catch(function (error) {
            console.log(error)
             this.$loading(false)
          }); 
        }            
      },

    }
};
</script>
